/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';
import { Observable } from 'rxjs';

export class MessageApi extends BaseApi {
  endPoint: string = '/api/admin/messages';

  public read(_postBody: any): Observable<any> {
    const _routeParams: any = {};
    return this._post(this.endPoint + '/read', _routeParams, _postBody);
  }

  public findByRecipient(id: any): Observable<any> {
    return this._unimplemented('findByRecipient');
  }

  public findByOwner(id: any): Observable<any> {
    return this._unimplemented('findByOwner');
  }
}
